module.exports = __webpack_public_path__ + "img/bank.8a44d2b3.png";